
  import Alpine from 'alpinejs';
  import { deactivateInsurance } from "../../_svelte/api/deactivateInsurance";
  
  // initialize alpine
  window.Alpine = Alpine;

  const urlParams = new URLSearchParams(window.location.search);
  const travelId = urlParams.has('id') && urlParams.get('id');

  // build the config object for the api Requests
  let apiRequestConfig = {
    travelId: travelId,
    apis: {
      auth: {
        subscriptionKey: 'E0B293EA-5CD0-E711-80D7-00155DD475CE',
        clientId: 'ordering-flow-a1srb',
        clientSecret: 'C6EMmSEwwbm6MgrmsBX7QjrlyKKZCFeM',
      },
      methods: {
        accessToken: 'https://lamie.systems/auth/realms/core/protocol/openid-connect/token',
        deactivate: 'https://lamie.systems/travel/api/v1/travels/deactivate'
      }
    },
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('request', () => ({
      success: false,
      error: null,
      disabled: false,
      loading: false,
      init() {
        if (!travelId) {
          this.error = 'No travel ID provided';
          this.disabled = true;
          return;
        }
      },
      async submit() {
        this.disabled = true;
        this.loading = true;

        deactivateInsurance(apiRequestConfig).then(response => {
          this.disabled = false;
          this.loading = false;
          this.error = null;

          if (response.status === 'error') {
            console.error('Deactivation error:', response);
            if (response.code === 422) {
              this.error = 'Rok za deaktivaciju pokrića na trenutnom putovanju je istekao.';
              this.disabled = true;
            } else {
              this.error = 'Došlo je do greške prilikom pokušaja deaktivacije Pametnog putnog osiguranja.';
            }
          } else {
            this.success = true;
          }
        });
      }
    }))
  });

  Alpine.start();
